import React from 'react';
import PropTypes from 'prop-types';

import DealWarning from './deal_warning';
import Select from './select';

// TODO: Should have more generic helpers outside of vouchers
import { isCondo, isLot, isSale } from 'bundles/backoffice/vouchers/helpers/listings';

export const newListingId = 'new';

export default function ListingSelector({ deal, listing, project, onChange }) {
  React.useEffect(() => {
    if (deal.dealType === 'sale' && project && !listing) {
      onChange(project.listings.find(listing => isSale({ listing })));
    }
  }, [deal, listing, project]);

  if (!project) {
    return null;
  }

  const inputs = [];
  if (deal.dealType === 'sale') {
    const lotListings = project.listings.filter(listing => isLot({ listing }));
    if (lotListings.length) {
      inputs.push(
        <Select
          key="lot"
          label="Lot"
          listing={listing}
          listings={lotListings}
          name="lots"
          onChange={onChange}
        />
      );
    }

    const condoListings = project.listings.filter(listing => isCondo({ listing }));
    if (condoListings.length) {
      inputs.push(
        <Select
          key="condo"
          label="Condo"
          listing={listing}
          listings={condoListings}
          name="condos"
          onChange={onChange}
        />
      );
    }
  } else {
    inputs.push(
      <Select
        allowNew
        key="leaseSpace"
        label="Lease Space"
        listing={listing}
        listings={project.listings}
        onChange={onChange}
      />
    );
  }

  return (
    <div>
      {inputs}
      <DealWarning listing={listing} />
    </div>
  );
}

ListingSelector.propTypes = {
  deal: PropTypes.shape({
    dealType: PropTypes.string.isRequired,
  }).isRequired,
  listing: PropTypes.object,
  project: PropTypes.shape({
    listings: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string,
    })),
  }),
  onChange: PropTypes.func.isRequired,
};
